import React, { useState, useEffect } from "react";
import './Rogfilter.css'; // Use your existing filter CSS

const GenericFilter = ({ products, priceRange, filters = {}, onFilterChange }) => {
  const [availableBrands, setAvailableBrands] = useState([]);
  const [availableModels, setAvailableModels] = useState([]);
  const [availableConditions, setAvailableConditions] = useState([]);

  // Ensure filters have default values to prevent controlled/uncontrolled input issues
  const safeFilters = {
    availability: filters.availability || [],
    condition: filters.condition || [],
    brand: filters.brand || [],
    model: filters.model || []
  };

  // Extract unique values from products for filter options
  useEffect(() => {
    if (products && products.length > 0) {
      const brands = [...new Set(products.map(p => p.brand).filter(Boolean))].sort();
      const models = [...new Set(products.map(p => p.model).filter(Boolean))].sort();
      const conditions = [...new Set(products.map(p => p.condition).filter(Boolean))].sort();
      
      setAvailableBrands(brands);
      setAvailableModels(models);
      setAvailableConditions(conditions);
    }
  }, [products]);

  const handlePriceRangeChange = (e) => {
    const newPriceRange = e.target.value;
    onFilterChange(filters, newPriceRange);
  };

  const handleCheckboxChange = (category, value) => {
    const newFilters = { ...safeFilters };
    
    const updatedCategory = newFilters[category].includes(value)
      ? newFilters[category].filter((item) => item !== value)
      : [...newFilters[category], value];

    newFilters[category] = updatedCategory;
    onFilterChange(newFilters, priceRange);
  };

  const clearAllFilters = () => {
    const clearedFilters = {
      availability: [],
      condition: [],
      brand: [],
      model: [],
    };
    onFilterChange(clearedFilters, 2000000);
  };

  const hasActiveFilters = () => {
    return safeFilters.availability.length > 0 || 
           safeFilters.condition.length > 0 ||
           safeFilters.brand.length > 0 || 
           safeFilters.model.length > 0 || 
           priceRange < 2000000;
  };

  // Get availability status based on product properties
  const getAvailabilityStatus = (product) => {
    if (product.isPreOrder) return "Pre-Order";
    if (product.stock > 0) return "In Stock";
    return "Out of Stock";
  };

  // Get unique availability statuses from actual products
  const getAvailableStatuses = () => {
    if (!products || products.length === 0) return [];
    
    const statuses = new Set();
    products.forEach(product => {
      statuses.add(getAvailabilityStatus(product));
    });
    
    return Array.from(statuses).sort();
  };

  // Get condition display name
  const getConditionDisplayName = (condition) => {
    switch(condition) {
      case 'brandnew': return 'Brand New';
      case 'used': return 'Used';
      default: return condition;
    }
  };

  const availableStatuses = getAvailableStatuses();

  return (
    <div className="rog-filter">
      {/* Clear Filters Button */}
      {hasActiveFilters() && (
        <button 
          onClick={clearAllFilters}
          className="clear-all-filters-btn"
        >
          Clear All Filters
        </button>
      )}

      {/* Price Range */}
      <h2>PRICE RANGE</h2>
      <p className="price-range">0 LKR - {parseInt(priceRange).toLocaleString()} LKR</p>
      <input
        type="range"
        min="15000"
        max="2000000"
        value={priceRange}
        onChange={handlePriceRangeChange}
        className="price-slider"
      />

      {/* Availability Filter */}
      {availableStatuses.length > 0 && (
        <div className="filter-section">
          <h3>AVAILABILITY</h3>
          {availableStatuses.map((status) => (
            <label key={status}>
              <input
                type="checkbox"
                checked={safeFilters.availability.includes(status)}
                onChange={() => handleCheckboxChange("availability", status)}
              />
              {status}
            </label>
          ))}
        </div>
      )}

      {/* Condition Filter */}
      {availableConditions.length > 0 && (
        <div className="filter-section">
          <h3>CONDITION</h3>
          {availableConditions.map((condition) => (
            <label key={condition}>
              <input
                type="checkbox"
                checked={safeFilters.condition.includes(condition)}
                onChange={() => handleCheckboxChange("condition", condition)}
              />
              {getConditionDisplayName(condition)}
            </label>
          ))}
        </div>
      )}

      {/* Brand Filter - Only show if brands exist for this category */}
      {availableBrands.length > 0 && (
        <div className="filter-section">
          <h3>BRAND</h3>
          {availableBrands.map((brand) => (
            <label key={brand}>
              <input
                type="checkbox"
                checked={safeFilters.brand.includes(brand)}
                onChange={() => handleCheckboxChange("brand", brand)}
              />
              {brand}
            </label>
          ))}
        </div>
      )}

      {/* Model Filter - Only show if models exist for this category */}
      {availableModels.length > 0 && (
        <div className="filter-section">
          <h3>MODEL</h3>
          {availableModels.map((model) => (
            <label key={model}>
              <input
                type="checkbox"
                checked={safeFilters.model.includes(model)}
                onChange={() => handleCheckboxChange("model", model)}
              />
              {model}
            </label>
          ))}
        </div>
      )}

      {/* Active Filters Count */}
      {hasActiveFilters() && (
        <div className="active-filters-display">
          <strong>Active Filters:</strong>
          <div className="active-filters-list">
            {safeFilters.availability.length > 0 && (
              <div>• Availability: {safeFilters.availability.length}</div>
            )}
            {safeFilters.condition.length > 0 && (
              <div>• Condition: {safeFilters.condition.length}</div>
            )}
            {safeFilters.brand.length > 0 && (
              <div>• Brands: {safeFilters.brand.length}</div>
            )}
            {safeFilters.model.length > 0 && (
              <div>• Models: {safeFilters.model.length}</div>
            )}
            {priceRange < 2000000 && (
              <div>• Price: Up to {parseInt(priceRange).toLocaleString()} LKR</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default GenericFilter;